<template>
  <div>
    <v-dialog class="ibx-report-issue-modal" v-model="showDialog" persistent max-width="600">
      <v-card class="ibx-report-issue-modal__content">
        <v-card-title class="headline">
          Report an Issue
          <v-spacer></v-spacer>
          <font-awesome-icon :icon="['fal', 'times']" class="icon close-discard-dialog" @click="resetFormAndClose" />
        </v-card-title>
        <v-card-text> Select the issue you would like to report: </v-card-text>
        <v-form ref="form">
          <v-card-text>
            <v-container>
              <v-list-item v-for="(issue, i) in listIssues" :key="i" class="report-checkbox-list__item">
                <v-list-item-action>
                  <v-checkbox
                    class="report-checkbox-list__control"
                    :label="issue"
                    color="primary"
                    :value="issue"
                    v-model="selectedList"
                  />
                </v-list-item-action>
              </v-list-item>
            </v-container>
          </v-card-text>
          <v-card-text>
            <v-flex xs12 sm6 md12 pb-2> Comment(s): </v-flex>
            <v-flex xs12 sm12 md12>
              <v-textarea
                class="ibx-report-issue-modal__text-area"
                type="text"
                autofocus
                outlined
                solo
                rows="3"
                v-model="comment"
                >Comments</v-textarea
              >
            </v-flex>
          </v-card-text>
        </v-form>

        <v-card-actions class="item-author-confirm-dialog__footer">
          <v-spacer></v-spacer>
          <x-btn color="ghost" no-outiline @click="resetFormAndClose">Cancel</x-btn>
          <x-btn @click="saveFeedbackModal" :disabled="isDisable">{{ isDisable ? 'Submitting...' : 'Submit' }}</x-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ibx-report-success-modal />
  </div>
</template>

<script>
import * as VDialog from 'vuetify/es5/components/VDialog'
import { EventBus, Events } from '@events'
import IBXService from '@services/ibx/IBXService'
import * as VCheckbox from 'vuetify/es5/components/VCheckbox'
import IbxReportSuccessModal from '@components/ibx/IbxReportSuccessModal'
import { CONST } from '@constants'

export default {
  name: 'IbxReportIssueModal',

  components: {
    ...VCheckbox,
    ...VDialog,
    IbxReportSuccessModal,
  },

  data: () => ({
    showDialog: false,
    isDisable: false,
    data: null,
    listIssues: [
      'Correct answer choice is incorrect',
      'Spelling or grammar error',
      'Incorrectly aligned standard',
      'Broken image',
      'PDF display inconsistent/broken',
      'Needs revision (example: too wordy or unclear)',
      'Incorrectly identified difficulty or level',
    ],
    selectedList: [],
    comment: '',
  }),

  methods: {
    init({ itemData }) {
      this.data = itemData
      this.showDialog = true
    },

    saveFeedbackModal() {
      this.isDisable = true
      // preparing Data.
      let data = {
        selectedItem: this.selectedList,
        comment: this.comment,
        item: {
          itemId: this.data.itemId,
          itemRevId: this.data.itemRevId,
          externalId: this.data.externalIds.length ? this.data.externalIds?.[0]?.id : '-',
        },
      }
      IBXService.sendEmail({ data })
        .then(() => {
          this.resetFormAndClose()
          EventBus.$emit('success_modal')
        })
        .catch((error) => {
          EventBus.$emit(Events.ERROR, {
            type: CONST.ERROR,
            error,
            text: 'Failed to send email',
            subtext: 'Please try again.',
          })
          this.resetFormAndClose()
        })
    },
    resetFormAndClose() {
      this.$refs.form.reset()
      this.showDialog = false
      this.isDisable = false
    },
  },
  created() {
    EventBus.$on(Events.REPORT_ISSUE, this.init)
  },
}
</script>

<style lang="scss">
@import '@/styles/main';

.report-checkbox-list {
  color: $N130 !important;
  display: block;

  &__item {
    margin-bottom: 12px;
    padding: 0 0 0 0 !important;

    .v-item__tile.theme--light {
      height: auto;
    }
  }

  .v-input__control .v-input__slot {
    .v-input--selection-controls__input {
      margin-right: 8px !important;
    }
  }
}

.v-label {
  color: $N110 !important;
}

.v-label:hover {
  color: $B300 !important;
}
.close-discard-dialog {
  cursor: pointer;
}
</style>
